module.exports = __webpack_public_path__ + "img/18.02182333.jpg";